/** Same-origin proxy URL Magic souboru (cookie auth). */
export function wwwFileUrl(fileId: number): string {
  return `/api/www/files/${fileId}`;
}
